<template lang="pug">
  div(
  v-if="mappingConfObject && options.length > 0"
  ).type-group.map-mapping-selector
    div.type
      label.checked
        span
        span.marker Тематическая карта
      label.new-check
        input.new-checkbox(type="checkbox" v-model="showMappingLayer")
        span

    div(
    v-show="showMappingLayer"
    v-for="option in options"
    ).group
      div.type
        label.checked.radioButton
          input(
          type="radio"
          v-model="selected"
          @change="onChange"
          :value="option.id"
          ).radio
          span
          span.marker {{option.name}}
</template>

<script>
  export default {
    name: 'map-mapping-selector',
    props: {
      mappingConfObject: Object,
      selectedMappingObject: [Number, String]
    },
    data () {
      return {
        selected: ''
      }
    },
    watch: {
      'selectedMappingObject': 'onSelectedMappingObject',
      'showMappingLayer': 'onShowMappingLayer'
    },
    computed: {
      options () {
        let items = []
        for (let key in this.mappingConfObject) {
          items.push({
            id: key, name: this.mappingConfObject[key].title
          })
        }
        return items
      },
      showMappingLayer: {
        get () {
          return this.$store.state.showMappingLayer
        },
        set (value) {
          this.$store.commit('mappingLayer', value)
        }
      }
    },
    methods: {
      onShowMappingLayer (newVal) {
        if (newVal === true) {
          this.onSelectedMappingObject(this.savedSelected)
          this.onChange()
        } else {
          this.savedSelected = this.selected
          this.onSelectedMappingObject('')
          this.onChange()
        }
      },
      onSelectedMappingObject (val) {
        this.selected = val
      },
      onChange () {
        this.$emit('change', this.selected)
      }
    }
  }
</script>
